var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.24521 0.561622C1.91071 -0.103874 2.98934 -0.103874 3.65448 0.561622L11.6855 8.59269L19.7166 0.561622C20.3821 -0.103874 21.4607 -0.103874 22.1259 0.561622C22.7914 1.22712 22.7914 2.30575 22.1259 2.97089L14.0948 11.002L22.1259 19.033C22.7914 19.6985 22.7914 20.7772 22.1259 21.4423C21.4604 22.1078 20.3818 22.1074 19.7166 21.4423L11.6855 13.4112L3.65448 21.4423C2.98899 22.1074 1.91035 22.1074 1.24521 21.4423C0.57972 20.7768 0.57972 19.6982 1.24521 19.033L9.27628 11.002L1.24521 2.97089C0.57972 2.3054 0.57972 1.22676 1.24521 0.561622Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/closeModal.67d7cb767376043b8f25b752fa596e1d.svg";
export { ForwardRef as ReactComponent };